/**
 * 按 390x844 逻辑坐标绝对定位的容器（T01 外壳专用）。
 *
 * 同一份 `layout` 既用于内联定位、又用于组件清单登记，保证「页面上看到的部件」
 * 与 `docs/UI-COMPONENT-MANIFEST.md` 里的坐标一致 —— 这是安卓移植的硬要求。
 */
import type { ReactElement, ReactNode } from 'react';

import { buildComponentMeta, useComponentMeta } from '../ui';
import type { ComponentMetaInput } from '../ui';

export interface FrameBoxProps {
  /** 组件元数据输入（含 390x844 逻辑坐标）。 */
  meta: ComponentMetaInput;
  className?: string;
  children?: ReactNode;
  surface?: 'page' | 'panel' | 'control' | 'overlay';
}

export function FrameBox({ meta, className, children, surface }: FrameBoxProps): ReactElement {
  const componentMeta = buildComponentMeta(meta, 'container');
  const ref = useComponentMeta<HTMLDivElement>(componentMeta);
  const { layout } = meta;

  return (
    <div
      ref={ref}
      className={className}
      data-ui-id={componentMeta.id}
      data-ui-role={componentMeta.role}
      data-skin-surface={surface}
      style={{
        position: 'absolute',
        left: layout.x,
        top: layout.y,
        width: layout.width,
        height: layout.height,
        zIndex: componentMeta.zIndex,
      }}
    >
      {children}
    </div>
  );
}
